module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-black",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-window-maximize m-r-xs"
  }), _vm._v(" Controle "), _c('span', {
    staticClass: "m-l-sm caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu no-padder"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'leilao.monitor-comitente',
        params: {
          leilao: _vm.leilao.id
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-history fa-fw"
  }), _vm._v(" Acompanhamento Comitente")])], 1), _vm._v(" "), (_vm.ACL.check('controlar_leilao', _vm.currentUser.id)) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'pregao',
        params: {
          id: _vm.leilao.id
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-gamepad fa-fw"
  }), _vm._v(" Controle do Leilão")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'pregaoleiloeiro',
        params: {
          id: _vm.leilao.id
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-drivers-license fa-fw"
  }), _vm._v(" Tela Leiloeiro")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "opacity": "0.5"
    },
    attrs: {
      "target": "_blank",
      "href": 'https://www.consorciorioparkingcarioca.com/leiloes/' + _vm.leilao.id + '/?pregoeiro=1',
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-fw"
  }), _vm._v(" Apresentação Telão Antigo")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'apresentacao-lotes',
        params: {
          id: _vm.leilao.id
        },
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-fw"
  }), _vm._v(" Apresentação Telão")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://lotes.consorciorioparkingcarioca.com/#/?leilao=' + _vm.leilao.id,
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders fa-fw"
  }), _vm._v(" Apresentação Lotes")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'pregaolance2',
        params: {
          id: _vm.leilao.id
        },
        query: {
          version: 2
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-fw"
  }), _vm._v(" TV Lance")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'pregaolance-cronometro',
        params: {
          id: _vm.leilao.id
        },
        query: {
          version: 2
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-fw"
  }), _vm._v(" TV Lance Leiloeiro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'pregaoleiloeiropatio',
        params: {
          id: _vm.leilao.id
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-fw"
  }), _vm._v(" Auxílio Pátio")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c961b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/BtnControle.vue
// module id = 1861
// module chunks = 18